module.exports = __webpack_public_path__ + "media/testimonials/customer-1-cb89534e.png";